export enum WorkflowType {
	CALL = 'callWorkflows',
	WEBHOOK = 'call_webhook_workflows',
	EMAIL = 'email_workflow',
	CALENDAR = 'calendar_workflow',
	TEXT = 'workflows',
	INTAKE = 'intake_questions_workflows',
}

export enum FormActionType {
	ADD = 'ADD',
	EDIT = 'EDIT',
}
